import NextLink from 'next/link';

import {AnimatedText, Button} from '#component/base';
import {EventType, useAnalytics, UserActionEvent} from '#component/provider/AnalyticsProvider';
import {Transition} from '#component/util';
import {sprinkles} from '#style/sprinkles';

import {StepProps} from '../../StorySteps.types';

import * as css from './Step7.css';

export const Step7 = ({afterEnter, hasActiveSubscription, show, surveySubmissionId}: StepProps) => {
  const {track} = useAnalytics();

  const handleSubscribe = () => {
    track<UserActionEvent>({actionName: 'View story upsell', evtName: EventType.UserAction});
  };

  let renderedHeading: JSX.Element;
  let renderedSubheading: JSX.Element;
  let renderedCta: JSX.Element;

  // State A is displayed when user has not completed the associated Lifestyle Survey
  if (!surveySubmissionId) {
    renderedHeading = (
      <AnimatedText color="white" variant="heading1">
        We’re here to guide you
      </AnimatedText>
    );

    renderedSubheading = (
      <AnimatedText color="white" fontWeight="semiBold" variant="bodyLarge">
        Take our Lifestyle Survey to receive personalized recommendations designed to lower your
        TallyAge™ and drive improved health, vibrancy, and longevity.
      </AnimatedText>
    );

    renderedCta = (
      <NextLink href="/survey" passHref>
        <Button as="a" variant="primary-dark">
          Take your Lifestyle Survey
        </Button>
      </NextLink>
    );
  }
  // State B is displayed when user has completed the associated Lifestyle Survey and has an active subscription
  else if (hasActiveSubscription) {
    renderedHeading = (
      <>
        <AnimatedText color="white" variant="heading1">
          We’re here to guide you
        </AnimatedText>
      </>
    );

    renderedSubheading = (
      <AnimatedText color="white" fontWeight="semiBold" variant="bodyLarge">
        Explore your updated Lifestyle Summary to learn more about the areas you can work on to
        improve your TallyAge™.
      </AnimatedText>
    );

    renderedCta = (
      <NextLink href="/mytallyage" passHref>
        <Button as="a" variant="primary-dark">
          View your Lifestyle Summary
        </Button>
      </NextLink>
    );
  }
  // State C is displayed when user has completed the associated Lifestyle Survey but does not have an active subscription
  else {
    renderedHeading = (
      <AnimatedText color="white" variant="heading1">
        Become a Tally Health™ member
      </AnimatedText>
    );

    renderedSubheading = (
      <AnimatedText color="white" fontWeight="semiBold" variant="bodyLarge">
        Become a Tally Health™ member to get an analysis of your lifestyle and a personalized Action
        Plan to guide you on your journey.
      </AnimatedText>
    );

    renderedCta = (
      <NextLink href="/profile?tab=manage" passHref>
        <Button as="a" onClick={handleSubscribe} variant="primary-dark">
          Join now
        </Button>
      </NextLink>
    );
  }

  return (
    <Transition afterEnter={afterEnter} className={css.root} show={show}>
      <div className={sprinkles({flex: 'flex', dir: 'col', gap: 16})}>
        <div className={sprinkles({flex: 'flex', dir: 'col'})}>{renderedHeading}</div>
        {renderedSubheading}
      </div>
      {renderedCta}
    </Transition>
  );
};
